import { userAreaNameDtoSchema, userDtoSchema, userWithAssignedRolesDtoSchema } from "@datamole/lssa-api-schema";
import { z } from "zod";

export const userAreaNameSchema = userAreaNameDtoSchema;
export const userSchema = userDtoSchema;
export const usersWithAssignedRolesSchema = z.array(userWithAssignedRolesDtoSchema);
